// Yubiley-korporativ — variant. Renders /templates/yubiley-korporativ.html
// (corporate-anniversary, paper + gold + teal, Bodoni Moda) inside a
// full-bleed iframe. The HTML's customizer reads
// company/years/date/time/venue/address/phone/email/organiser/dress
// from the query string. We map this template's "names" field as
// "Company · Years" (e.g. "Sharq Texnologiya · 10") and split it
// before passing to the iframe.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/yubiley-korporativ.html";

export function YubileyKorporativStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();

  // Catalog "names" carries "Company · 10" — split into company / years.
  if (t.names) {
    const [company, years] = t.names.split(/\s*[·•]\s*/);
    if (company) params.set("company", company.trim());
    const yr = years?.match(/\d+/)?.[0];
    if (yr) params.set("years", yr);
  }
  if (t.date) {
    // dd.mm.yyyy → ISO yyyy-mm-dd
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.time) params.set("time", t.time);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  // Demo / preview surfaces leave ctx.slug undefined.
  if (ctx.slug) params.set("slug", ctx.slug);
  // Cache buster — bump when the static HTML changes.
  params.set("v", "2");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;
  return (
    <iframe
      src={src}
      title={t.names || "Yubiley"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#F5EFE6",
      }}
    />
  );
}
